import { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
    getOrdersTeam
} from "actions/productActions";
import { ListDateType } from "helper/constant";
import { formatterCreateAt, convertTZ, subStringText, countString } from "components/Function";
import Loading from "components/Loading";
import ReactImageMagnify from "react-image-magnify";

const MAGNIFY_PORTAL_ID = "magnify-portal-orders-team";

const OrdersTeam = ({
    getOrdersTeam,
    productSuggest,
    formatterCreateAt,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [filter, setFilter] = useState({});
    const { t } = useTranslation();
    const { list, totalsize, isLoading } = productSuggest;

    const sizePerPageList = [
        {
            text: "10",
            label: "10",
            value: 10,
        },
        {
            text: "50",
            label: "50",
            value: 50,
        },
        {
            text: "100",
            label: "100",
            value: 100,
        },
        {
            text: "150",
            label: "150",
            value: 150,
        },
    ];

    useEffect(() => {
        if (Object.keys(filter).length) {
            getOrdersTeam({ page, sizeperpage: sizePerPage, search: searchText, filter });
        }
    }, [getOrdersTeam, page, sizePerPage, searchText, filter]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    // const handleSchedule = (id) => {
    //     setRowShow(id)
    //     console.log(rowShow)
    //     Swal.fire(t("Success"), id, "success");

    // };

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const totalPages = useMemo(() => {
        const total = Math.ceil((totalSize || 0) / (sizePerPage || 1));
        return total > 0 ? total : 1;
    }, [totalSize, sizePerPage]);

    const handleSearchChange = (e) => {
        setPage(1);
        setSizePerPage(50);
        setSearchText(e.target.value);
    };

    const handleChangePage = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleChangePageSize = (value) => {
        setSizePerPage(value);
        setPage(1);
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5">
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
            </>
        );
    };

    return (
        <div className="card min-w-full">
            <div
                id={MAGNIFY_PORTAL_ID}
                style={{ position: "fixed", top: 0, left: 0, zIndex: 2147483647 }}
            />
            <Loading isLoading={isLoading} />
            <div className="card-body">
                <div className="d-flex flex-wrap align-items-center mb-4">
                    <div className="me-3 mb-2">{groupButton()}</div>
                    <div className="flex-grow-1 mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder={t("Search")}
                            value={searchText}
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="ms-auto mb-2 d-flex align-items-center">
                        <span className="me-2">{t("Page size")}:</span>
                        <Select
                            className="basic-multi-select al-custom-select-search-variants mb-0"
                            classNamePrefix="select"
                            name="pageSize"
                            options={sizePerPageList}
                            value={sizePerPageList.find((opt) => opt.value === sizePerPage)}
                            onChange={(opt) => handleChangePageSize(opt.value)}
                            isSearchable={false}
                            menuPlacement="auto"
                            styles={{ container: (base) => ({ ...base, width: 120 }) }}
                        />
                    </div>
                </div>
                {list?.length ? (
                    <div className="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-4">
                        {list.map((item, idx) => (
                            <div className="col" key={`${item.title}-${idx}`}>
                                <div className="card h-100 shadow-sm position-relative" style={{ overflow: "hidden" }}>
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "12px",
                                            right: "-38px",
                                            width: "140px",
                                            background: "#ff7043",
                                            color: "#fff",
                                            textAlign: "center",
                                            transform: "rotate(45deg)",
                                            fontWeight: 700,
                                            fontSize: "12px",
                                            padding: "6px 0",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                            zIndex: 2,
                                            cursor: "default",
                                        }}
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={`${t("Total Sold")}: ${item.count}`}
                                    >
                                        {item.count}
                                    </div>
                                    <div className="card-body d-flex flex-column align-items-center text-center">
                                        <div className="mb-3">
                                            <div className="symbol symbol-120px">
                                                <Link to={item.image || "#"} target="_blank">
                                                    <ReactImageMagnify
                                                        {...{
                                                            smallImage: {
                                                                alt: "",
                                                                width: 200,
                                                                height: 200,
                                                                src: item.image || require("components/assets/media/misc/image.png"),
                                                            },
                                                            largeImage: {
                                                                src: item.image || require("components/assets/media/misc/image.png"),
                                                                width: 600,
                                                                height: 600,
                                                            },
                                                            enlargedImageContainerDimensions: { width: "300%", height: "300%" },
                                                            enlargedImageContainerStyle: {
                                                                zIndex: 2147483647,
                                                                position: "fixed",
                                                                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                                                            },
                                                            className: "cursor-pointer",
                                                            enlargedImageContainerClassName: "al-zoom-img-cus",
                                                            imageStyle: { zIndex: 2147483647 },
                                                        }}
                                                    />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 w-100">
                                            <h6
                                                className="mb-2"
                                                title={item.title || ""}
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                }}
                                            >
                                                {item.title || t("Unknown")}
                                            </h6>
                                            <div className="text-muted">
                                                <span data-tooltip-id="my-tooltip" data-tooltip-content={formatterCreateAt(+item.create_time * 1000)}>
                                                    {formatterCreateAt(+item.create_time * 1000)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-5">{t("No data!")}</div>
                )}

                <div className="d-flex justify-content-between align-items-center mt-4">
                    <div>
                        <span>
                            {t("Page")} {page} / {totalPages} ({t("Total")}: {totalSize})
                        </span>
                    </div>
                    <div className="btn-group">
                        <button
                            className="btn btn-light"
                            onClick={() => handleChangePage(page - 1)}
                            disabled={page <= 1}
                        >
                            {t("Prev")}
                        </button>
                        <button
                            className="btn btn-light"
                            onClick={() => handleChangePage(page + 1)}
                            disabled={page >= totalPages}
                        >
                            {t("Next")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ productSuggest }) => ({ productSuggest });
const mapDispatchToProps = {
    getOrdersTeam,
    formatterCreateAt,
    subStringText,
    countString,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersTeam);
